import { useMemo } from 'react';
import { getUserCacheData, UserSessionCacheKeys } from 'Shared/services/sessionCacheService';

/**
 * Hook to check if the user has been a member for a certain number of days
 * @param days
 */
const useMembershipDuration = (days: number): boolean => {
  const initialData = getUserCacheData(UserSessionCacheKeys.USER_INFO_WITH_DATES);
  const createdAt   = initialData?.createdAt;

  return useMemo(() => {
    if (!createdAt) {
      return false;
    }

    const today          = new Date();
    const joinedDate     = new Date(createdAt);
    const daysDifference = Math.floor((today.getTime() - joinedDate.getTime()) / (1000 * 60 * 60 * 24));

    return daysDifference > days;
  }, [days, createdAt]);
};

export default useMembershipDuration;